// dynamic-support-category-page.tsx

import React from "react";
import { useParams } from "react-router-dom";
import { Typography, Container } from "@mui/material";
import { useSupportDataLoader } from "../contexts/support-data-loader";
import SupportCategoryPage from "./support-category-page";

const slugify = (str: string) => str.toLowerCase().trim().replace(/\s+/g, "-");

const DynamicSupportCategoryPage: React.FC = () => {
  const { category } = useParams<{ category: string }>();
  const { supportData, isLoading } = useSupportDataLoader();

  if (isLoading) {
    return (
      <Container maxWidth="md" sx={{ mt: 4 }}>
        <Typography>Loading category...</Typography>
      </Container>
    );
  }

  const categoryData = supportData.find(
    (c) => slugify(c.name) === decodeURIComponent(category),
  );

  if (!categoryData) {
    return (
      <Container maxWidth="md" sx={{ mt: 4 }}>
        <Typography variant="h5" color="error">
          Category not found.
        </Typography>
      </Container>
    );
  }

  return (
    <SupportCategoryPage
      categoryTitle={categoryData.name}
      categorySlug={category}
      articles={categoryData.articles || []}
    />
  );
};

export default DynamicSupportCategoryPage;
